import { Table as ReactTable } from '@tanstack/react-table';
import { RequireExactlyOne } from 'type-fest';

import { Skeleton, Table, TableProps, Tbody, Td, Th, Thead, Tr } from '@oaknorth/component-core-v2';

type CustomTableLoadingProps<T extends object> = RequireExactlyOne<
  {
    table: ReactTable<T>;

    /**
     * total number of data rows to display (+ 1 header row)
     */
    numberOfRows: number;

    /**
     * Customise size of the skeleton to match the table it will be replaced by
     */
    size?: TableProps['size'];

    /**
     * Optional prop to use when a table object is unavailable to set the number of columns for
     * the loading state to show. Required if `table` is not provided.
     */
    numberOfColumns: number;
  },
  'table' | 'numberOfColumns'
>;

export const TableLoading = <T extends object = {}>({
  numberOfRows,
  table,
  size,
  numberOfColumns,
}: CustomTableLoadingProps<T>) => {
  const amountVisibleColumns = table?.getVisibleLeafColumns().length || numberOfColumns;

  return (
    <Table role="progressbar" size={size}>
      <Thead>
        <Tr>
          {[...Array(amountVisibleColumns)].map((_, i) => (
            <Th key={i}>
              <Skeleton width={20}>&nbsp;</Skeleton>
            </Th>
          ))}
        </Tr>
      </Thead>
      <Tbody>
        {[...Array(numberOfRows)].map((_, i) => (
          <Tr key={i}>
            {[...Array(amountVisibleColumns)].map((_, i) => (
              <Td key={i}>
                <Skeleton>&nbsp;</Skeleton>
              </Td>
            ))}
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};
